import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant';

@Injectable({
  providedIn: 'root'
})
export class PrivacyPolicyService {

  constructor(
    private http: HttpService
  ) { }

  getPrivacyPolicy(){
    return this.http.getWithoutAuth(Path.PRIVACY_POLICY.GET_PRIVACY_POLICY);
  }


}
